import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './FirebaseConfig'; // सही पथ का उपयोग करें

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError('');

      // Basic email validation
      if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
        throw new Error('Invalid email format');
      }

      // Basic password validation
      if (!password || password.length < 6) {
        throw new Error('Password should be at least 6 characters');
      }

      await signInWithEmailAndPassword(auth, email, password);
      console.log('Login successful');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login failed:', error.message);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      {/* Wireframe Background Elements */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `
          linear-gradient(90deg, rgba(139, 0, 0, 0.05) 1px, transparent 1px),
          linear-gradient(rgba(139, 0, 0, 0.05) 1px, transparent 1px)
        `,
        backgroundSize: '40px 40px',
        zIndex: 0
      }}></div>
      
      {/* Decorative Circles */}
      <div style={{
        position: 'absolute',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139, 0, 0, 0.1) 0%, transparent 70%)',
        top: '-150px',
        right: '-150px',
        zIndex: 0
      }}></div>
      
      <div style={{
        position: 'absolute',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139, 0, 0, 0.08) 0%, transparent 70%)',
        bottom: '-100px',
        left: '-100px',
        zIndex: 0
      }}></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-lg-5">
            <div className="card shadow-lg border-0" style={{
              borderRadius: '20px',
              overflow: 'hidden',
              zIndex: 1,
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              {/* Card Header with Gradient */}
              <div className="card-header py-4 border-0" style={{
                background: 'linear-gradient(135deg, #8B0000 0%, #6d0000 100%)'
              }}>
                <h2 className="text-white text-center mb-0 fw-bold">Admin Portal</h2>
                <p className="text-white text-center mb-0 mt-2 opacity-75">Secure access to dashboard</p>
              </div>
              
              <div className="card-body p-5">
                <form>
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label fw-semibold" style={{ color: '#555' }}>
                      Email Address
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-transparent border-end-0">
                        <i className="fas fa-envelope" style={{ color: '#8B0000' }}></i>
                      </span>
                      <input
                        type="email"
                        className="form-control border-start-0 py-3"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                        placeholder="Enter your admin email"
                        style={{ borderRadius: '0 8px 8px 0' }}
                      />
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label fw-semibold" style={{ color: '#555' }}>
                      Password
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-transparent border-end-0">
                        <i className="fas fa-lock" style={{ color: '#8B0000' }}></i>
                      </span>
                      <input
                        type="password"
                        className="form-control border-start-0 py-3"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                        placeholder="Enter your password"
                        style={{ borderRadius: '0 8px 8px 0' }}
                      />
                    </div>
                  </div>
                  
                  {error && (
                    <div className="alert alert-danger d-flex align-items-center" role="alert" style={{ borderRadius: '10px' }}>
                      <i className="fas fa-exclamation-circle me-2"></i>
                      <div>{error}</div>
                    </div>
                  )}
                  
                  <button
                    type="button"
                    className="btn w-100 py-3 fw-bold"
                    onClick={handleLogin}
                    disabled={loading}
                    style={{
                      background: 'linear-gradient(135deg, #8B0000 0%, #6d0000 100%)',
                      color: 'white',
                      borderRadius: '10px',
                      border: 'none',
                      transition: 'all 0.3s',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #6d0000 0%, #8B0000 100%)';
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #8B0000 0%, #6d0000 100%)';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Logging in...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Login to Dashboard
                      </>
                    )}
                  </button>
                  
                  <div className="text-center mt-4">
                    <small className="text-muted">
                      <i className="fas fa-shield-alt me-1"></i> Secure admin access only
                    </small>
                  </div>
                </form>
              </div>
            </div>
            
            {/* Footer Note */}
            <div className="text-center mt-4">
              <p className="text-muted small">
                &copy; {new Date().getFullYear()} Aditya Birla Finance. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Add Font Awesome for icons */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
    </div>
  );
};

export default AdminLogin;